var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 456.373,
    height: 456.373,
    viewBox: "0 0 456.373 456.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sun",
    d: "M322.173,1.065a14.413,14.413,0,0,1,8.556,10.606l17.735,96.163,96.163,17.646a14.413,14.413,0,0,1,10.606,8.556,14.157,14.157,0,0,1-1.426,13.547l-55.523,80.567,55.523,80.478a14.158,14.158,0,0,1,1.426,13.547,14.413,14.413,0,0,1-10.606,8.556l-96.163,17.735-17.735,96.163a14.413,14.413,0,0,1-8.556,10.606,14.158,14.158,0,0,1-13.547-1.426l-80.478-55.523-80.478,55.523a14.158,14.158,0,0,1-13.547,1.426,14.413,14.413,0,0,1-8.556-10.606l-17.735-96.163L11.671,330.729a14.413,14.413,0,0,1-10.606-8.556,14.158,14.158,0,0,1,1.426-13.547l55.523-80.478L2.491,147.672a14.158,14.158,0,0,1-1.426-13.547,14.413,14.413,0,0,1,10.606-8.556l96.163-17.735,17.735-96.163a14.413,14.413,0,0,1,8.556-10.606,14.158,14.158,0,0,1,13.547,1.426l80.478,55.523L308.627,2.491a14.158,14.158,0,0,1,13.547-1.426ZM142.592,228.149a85.558,85.558,0,1,1,85.558,85.557A85.558,85.558,0,0,1,142.592,228.149Zm199.634,0A114.077,114.077,0,1,0,228.149,342.226,114.077,114.077,0,0,0,342.226,228.149Z",
    transform: "translate(0.037 0.037)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.4e15539650b43b79653caa6a74828a4d.svg";
export { ForwardRef as ReactComponent };